import React from 'react';

interface StatsCardProps {
  title: string;
  stat: string;
  bgColorHex: string;
}

function StatsCard({ title, stat, bgColorHex }: StatsCardProps) {
  return (
    <div 
      className="p-8 shadow-xl border border-gray-100 rounded-3xl transition-transform hover:-translate-y-2 duration-300"
      style={{ backgroundColor: bgColorHex }}
    >
      <div className="text-4xl font-black mb-2 text-navy">
        {title}
      </div>
      <div className="text-xl font-medium text-gray-700">
        {stat}
      </div>
    </div>
  );
}

export default function HowItWorks() {
  return (
    <section className="py-24 bg-white" id="learn-more">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-center text-4xl md:text-5xl font-extrabold mb-16 text-navy">
          How it works?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          <StatsCard
            bgColorHex="#EAF2F4"
            title={"Find the course"}
            stat={"which fits your need"}
          />
          <StatsCard
            bgColorHex="#AEDDE0"
            title={"Contact the coach"}
            stat={"on WhatsApp or Phone Call"}
          />
          <StatsCard
            bgColorHex="#F9F2D4"
            title={"Book & Confirm"}
            stat={"the lesson of your choice"}
          />
        </div>
      </div>
    </section>
  );
}
